module.exports = {"410927100":"城关镇","410927101":"侯庙镇","410927102":"孙口镇","410927103":"打渔陈镇","410927104":"马楼镇","410927105":"吴坝镇","410927200":"后方乡","410927201":"清水河乡","410927205":"夹河乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410927.json
// module id = 1734
// module chunks = 0